import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import UserService from '../../../services/user-service';

import { Add } from './Stocks/Add';
import { List } from './Stocks/List';
import { Manage } from './Stocks/Manage';

import { GroupsList } from './Groups/List';
import { Add as AddGroup } from './Groups/Add';
import { ManageGroup } from './Groups/Manage';
import { UserRole } from 'smartbox-types';
import { useGetMyDetailsQuery } from 'src/queries';
import { Section, Tabs } from 'src/components/ui';
import { Stocks, Stocks2 } from 'src/icons';

const StockGroups = () => {
  const { data: user } = useGetMyDetailsQuery();
  const hasFullAccess = [UserRole.admin, UserRole.client].includes(user!.role);

  return (
    <>
      <Section>
        <Tabs
          tabs={[
            {
              to: `/${UserService.getSlugByRole(user!.role)}/locations/stocks`,
              text: 'application.stocks',
              icon: <Stocks2 />,
            },
            {
              to: `/${UserService.getSlugByRole(user!.role)}/locations/groups`,
              text: 'application.stockGroups',
              icon: <Stocks />,
            },
          ]}
        />
      </Section>
      <Switch>
        <Route
          exact
          path={`/${UserService.getSlugByRole(user!.role)}/locations`}
          render={() => (
            <Redirect
              to={`/${UserService.getSlugByRole(user!.role)}/locations/stocks`}
            />
          )}
        />
        <Route
          exact
          path={`/${UserService.getSlugByRole(user!.role)}/locations/stocks`}
          render={() => (
            <Redirect
              to={`/${UserService.getSlugByRole(user!.role)}/locations/stocks/list`}
            />
          )}
        />
        <Route
          exact
          path={`/${UserService.getSlugByRole(user!.role)}/locations/groups`}
          render={() => (
            <Redirect
              to={`/${UserService.getSlugByRole(user!.role)}/locations/groups/list`}
            />
          )}
        />
        {hasFullAccess && (
          <Route
            path={`/${UserService.getSlugByRole(user!.role)}/locations/stocks/add`}
            component={Add}
          />
        )}
        <Route
          path={`/${UserService.getSlugByRole(user!.role)}/locations/stocks/list`}
          component={List}
        />
        <Route
          path={`/${UserService.getSlugByRole(user!.role)}/locations/groups/list`}
          component={GroupsList}
        />
        {hasFullAccess && (
          <Route
            path={`/${UserService.getSlugByRole(user!.role)}/locations/groups/add`}
            component={AddGroup}
          />
        )}
        <Route
          path={`/${UserService.getSlugByRole(user!.role)}/locations/groups/:stockGroupId`}
          component={ManageGroup}
        />
        <Route
          path={`/${UserService.getSlugByRole(user!.role)}/locations/stocks/:stockId`}
          component={Manage}
        />
      </Switch>
    </>
  );
};

export { StockGroups };
